import React from "react";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import PropTypes from "prop-types";

const DesktopView = ({test, image, clockIcon}) => {
    return (
        <Card.Body>
            <div className="row d-flex">
                <div className="col-md-12 d-flex">
                    <div className="col-md-7 d-block">
                        <span className='action-required-title d-block'>{test?.test?.type_name}</span>
                        <span className='action-required-status gap-2 ageo-semibold'><span className='text-muted'>Status:</span> Action required <img src={clockIcon} alt="Clock Icon" /></span>
                        <span className="action-required-description d-block">Your test registration is incomplete, if your sample is collected, click the button below to register it now.</span>
                    </div>
                    <div className="col-md-5 d-flex align-items-center justify-content-end ageo-semibold">
                        <Button href={`/${test?.test?.detail_link}/resume/${test?.test?.id}/`}>Complete registration</Button>
                    </div>
                </div>
            </div>
        </Card.Body>
    )
}

DesktopView.propTypes = {
    test: PropTypes.shape({
        test: PropTypes.shape({
            type_name: PropTypes.string.isRequired,
            detail_link: PropTypes.string.isRequired,
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
    }).isRequired,
    image: PropTypes.string.isRequired,
    clockIcon: PropTypes.string.isRequired,
};

export default DesktopView;
